module.exports = __webpack_public_path__ + "img/avatar-4.dcc19a21.png";